<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import TtButton from '@/components/TtButton.vue'
const { t } = useI18n({ useScope: 'global' })

const paymentsHeadings = ref<String[]>([
  t('tools.date'),
  t('tools.payment'),
  t('tools.status'),
  ''
])

const paymentss = ref([
  {
    date: '2022-01-01',
    payment: '1234 sek',
    status: 'Paid',
    file: '/path/to/payments.pdf'
  },
  {
    date: '2022-01-01',
    payment: '1234 sek',
    status: 'Paid',
    file: '/path/to/payments.pdf'
  },
  {
    date: '2022-01-01',
    payment: '1234 sek',
    status: 'Paid',
    file: '/path/to/payments.pdf'
  },
  {
    date: '2022-01-01',
    payment: '1234 sek',
    status: 'Paid',
    file: '/path/to/payments.pdf'
  },
  {
    date: '2022-01-01',
    payment: '1234 sek',
    status: 'Paid',
    file: '/path/to/payments.pdf'
  },
  {
    date: '2022-01-01',
    payment: '1234 sek',
    status: 'Paid',
    file: '/path/to/payments.pdf'
  },
  {
    date: '2024-12-06',
    payment: '1234 sek',
    status: 'Unpaid',
    file: '/path/to/payments.pdf'
  }
])
</script>

<template>
  <div>
    <h2 class="text-2xl font-semibold">{{ t('tools.payments') }}</h2>

    <table
      class="w-full table-auto border-separate border-spacing-y-3 text-tt-gray"
    >
      <thead>
        <tr>
          <th
            v-for="item in paymentsHeadings"
            class="p-2 text-left text-base font-medium first:px-4"
          >
            {{ item }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="payments in paymentss.slice().reverse()"
          :key="payments.file"
          class=""
        >
          <td class="rounded-s-lg bg-white px-4 py-2">{{ payments.date }}</td>
          <td class="bg-white p-2">{{ payments.payment }}</td>
          <td class="bg-white p-2">
            <span class="inline-block">{{ payments.status === 'Paid' ? t('tools.paid') : t('tools.unpaid') }}</span>
            <span v-if="payments.status === 'Paid'" class="inline-block ml-2 align-middle">
              <svg class="h-3 w-3 text-tt-green">
                <circle cx="5" cy="5" r="5" fill="currentColor" />
              </svg>
            </span>
            <span v-else class="inline-block ml-2 align-middle">
              <svg class="h-3 w-3 text-tt-red">
                <circle cx="5" cy="5" r="5" fill="currentColor" />
              </svg>
            </span>
          </td>
          <td class="bg-white p-2 text-right">
            <TtButton
              :as="'router-link'"
              :to="payments.file"
              :size="'xsmall'"
              :type="'tertiary'"
            >
              {{ t('tools.download') }}
            </TtButton>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
